import { mapActions, mapMutations, mapState, mapGetters } from 'vuex';

export default {
  computed: {
    ...mapState('costCenters', ['costCenters']),
    ...mapGetters('auth', ['defaultCostCenter']),
  },
  methods: {
    ...mapMutations({
      setCostCenters: 'costCenters/setCostCenters',
      changeDefaultCostCenter: 'auth/changeDefaultCostCenter',
    }),
    ...mapActions({
      fetchCostCenters: 'costCenters/fetchCostCenters',
    }),
  },
};
